//=require _commom/jquery.min.js
//=require _commom/html5shiv.min.js
//=require _commom/respond.min.js

//=require ../../node_modules/bootstrap/dist/js/bootstrap.min.js
//=require ../../node_modules/owl.carousel/dist/owl.carousel.min.js
//=require ../../node_modules/fancybox/dist/js/jquery.fancybox.js

//=require componentes/menu.js
//=require componentes/loader.js
//=require componentes/mascaras.js
//=require componentes/vitrine.js
//=require componentes/fotos.js

//=require componentes/modais.js
//=require componentes/formularios.js